import { useEffect, useState } from "react";
import ResultRaces from "../../ResultsCard/ResultRaces";
import { APIResponse } from "../../../types/responses/APIResponse";
import { Track } from "../../../types/races/racecard";
import { fetchGet } from "../../../client";
import LoadingSpinner from "../../LoadingSpinner";
import { LoadingState } from "../../States/states";

export const ResultsListAttachment = ({
  trackSlug,
  id,
}: {
  trackSlug?: string;
  id: string;
}) => {
  const [data, setData] = useState<Track | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!trackSlug || !id) {
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        const res: APIResponse<{ track: Track }> = await fetchGet(
          `/racing/tracks/${trackSlug}/results?track_list_id=${id}`
        );

        if (res.track) {
          setData(res.track);
          setError(null);
        } else setError("No track data found");
      } catch (err) {
        setError(
          "Error loading FAQs: " +
            (err instanceof Error ? err.message : "Unknown")
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <LoadingState name="ResultsLoader" containerStyle={{ width: "100%" }} />
    );

  if (error || !data?.meetings) return null;

  return (
    <ResultRaces
      meetings={data?.meetings || []}
      headerOverride={null}
      trackOverride={data}
      openAtIndex={0}
    />
  );
};

export default ResultsListAttachment;
